export default "__VITE_ASSET__C3Ncwh6c__"